import { HttpContextToken, HttpInterceptor } from "@angular/common/http";
import { InjectionToken, Type } from "@angular/core";

// FYI this constants is not in libs/core/interceptors/
// because it create circular dependencies in lot of other libs

export const XSRF_TOKEN_NAME = "x-xsrf-token";
export const LOCALE_TOKEN_NAME = "x-hermes-locale";

export const HERMES_INTERCEPTORS = new InjectionToken<
    Record<string, Array<Type<HttpInterceptor>>>
>("HERMES_INTERCEPTORS");

export const HERMES_DEFAULT_INTERCEPTORS = new InjectionToken<
    Array<Type<HttpInterceptor>>
>("HERMES_DEFAULT_INTERCEPTORS");

export const SKIP_404_INTERCEPTOR = new HttpContextToken<boolean>(() => false);
